import React from "react";
import {
    FileTextOutlined,
    CalendarOutlined,
    DollarOutlined,
    LineChartOutlined,
    CreditCardOutlined,
    CheckCircleOutlined,
    InfoCircleOutlined
} from "@ant-design/icons";
import { Col, Row, Tag, Button } from "antd";
import CommonCard from "../../../global/card";
import { getMonthName } from "../../../../utils/functions";
import { useHistory } from "react-router-dom";

const EnhancedInvoicesDetails = ({
    invoiceDetail,
}) => {
    const history = useHistory();
    if (!invoiceDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            "Month": <CalendarOutlined />,
            "Year": <CalendarOutlined />,
            "Leads Imported": <LineChartOutlined />,
            "Lead Price": <DollarOutlined />,
            "Total Amount": <DollarOutlined />,
            "Status": <InfoCircleOutlined />,
        };
        return iconMap[label] || <InfoCircleOutlined />;
    };

    const payInvoice = (invoiceId) => {
        history.push("/paymentInvoice?invoice=" + invoiceId);
    };

    return (
        <div className="p-6" style={{ backgroundColor: "#f5f7fa" }}>
            <CommonCard
                title={
                    <div className="flex items-center gap-2">
                        <FileTextOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "18px" }} />
                        <span style={{ fontSize: "16px", fontWeight: 600 }}>Invoice Details</span>
                    </div>
                }
            >
                <Row gutter={[24, 0]}>
                    {/* Invoice Info Section */}
                    <Col span={24} className="border-b border-gray-200 py-4">
                        <div className="flex items-center gap-2 mb-4">
                            <FileTextOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "16px" }} />
                            <span style={{ fontSize: "15px", fontWeight: 600 }}>Invoice Information</span>
                        </div>
                        <Row gutter={[24, 16]}>
                            {[
                                {
                                    label: "Month",
                                    value: getMonthName(invoiceDetail.invoiceMonth),
                                    isTag: true,
                                    tagColor: "blue"
                                },
                                {
                                    label: "Year",
                                    value: invoiceDetail.invoiceYear
                                },
                                {
                                    label: "Leads Imported",
                                    value: invoiceDetail.totalLeadsImported,
                                    isTag: true,
                                    tagColor: "orange"
                                },
                                {
                                    label: "Lead Price",
                                    value: `${invoiceDetail.perLeadPrice} $`
                                },
                                {
                                    label: "Total Amount",
                                    value: `${invoiceDetail.totalAmount} $`,
                                    isTag: true,
                                    tagColor: "success"
                                },
                                {
                                    label: "Status",
                                    value: invoiceDetail.paymentStatus ? "Paid" : "Unpaid",
                                    isTag: true,
                                    tagColor: invoiceDetail.paymentStatus ? "success" : "error"
                                },
                            ].map((item) => (
                                <Col span={12} key={item.label}>
                                    <div className="flex flex-col">
                                        <span className="text-xs text-gray-500 flex items-center gap-2 mb-1">
                                            <span style={{ color: "var(--primary-color, #1890ff)" }}>
                                                {getIconForField(item.label)}
                                            </span>
                                            {item.label}
                                        </span>
                                        {item.isTag ? (
                                            <Tag color={item.tagColor || "blue"} className="m-0 px-3 py-1 font-medium capitalize w-fit">
                                                {item.value || "—"}
                                            </Tag>
                                        ) : (
                                            <span className="text-sm font-semibold text-gray-900">{item.value || "—"}</span>
                                        )}
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>

                    {/* Actions Section */}
                    {!invoiceDetail.paymentStatus && (
                        <Col span={24} className="py-6 flex justify-center">
                            <Button
                                type="primary"
                                size="large"
                                icon={<CreditCardOutlined />}
                                className="!bg-primary h-12 px-10 rounded-lg flex items-center gap-2 font-semibold shadow-md"
                                onClick={() => payInvoice(invoiceDetail._id)}
                            >
                                Pay Now
                            </Button>
                        </Col>
                    )}

                    {invoiceDetail.paymentStatus && (
                        <Col span={24} className="py-6 flex justify-center">
                            <div className="flex flex-col items-center gap-2 text-success">
                                <CheckCircleOutlined style={{ fontSize: "32px" }} />
                                <span className="text-base font-semibold">Payment Completed</span>
                            </div>
                        </Col>
                    )}
                </Row>
            </CommonCard>
        </div>
    );
};

export default EnhancedInvoicesDetails;
